export default __webpack_public_path__ + "static/media/DaCrazyUpdated.ca111450.png";